import type {App, Plugin} from 'vue';

function track(event: string, options: unknown = {}) {
    window.heap && window.heap.track(event, options);
}

const heap: Plugin = {
    install: (app: App): void => {
        app.config.globalProperties.$heap = {track};
    },
};

export default heap;
